import {T_SHIRT_SUBCAT_IDS} from './constants/categoryConstants';
import {featureFlagNotEligible} from './constants/signalmizelyConstants';
import {visualFiltersTest} from './featureFlags';

export const visualSubcategoryFiltersABTestTags = (variation) => {
  window.dataLayer.push({
    ab_test_group: variation,
    ab_test_location: 'plp catalog',
    ab_test_name: '2025 07 08 visual filters',
    event: 'ab_test_group'
  });
};

export const visualSubcategoryFiltersABTestEligible = (
  isInternal,
  isSearch,
  categoryId
) => {
  return !isInternal && !isSearch && T_SHIRT_SUBCAT_IDS.includes(categoryId);
};

export const useVisualSubcategoryFiltersABTest = (
  isInternal,
  isSearch,
  categoryId
) => {
  // Only call the visualFiltersTest hook if the user is eligible for the test as it'll bucket the session
  // into a variation (test, control, excluded) and we don't want to do that if the user is not eligible
  if (
    visualSubcategoryFiltersABTestEligible(isInternal, isSearch, categoryId)
  ) {
    return visualFiltersTest();
  }
  return featureFlagNotEligible();
};
